import 'url-search-params-polyfill'

import React, { Component } from 'react'

import Filters from './Filters'
import List from './List'
import DirectSearch from './DirectSearch'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

class Kursfinder extends Component {
  constructor (props) {
    super(props)

    const filterQuery = new URLSearchParams(window.location.search)

    let ageQuery
    if (filterQuery.get('age')) {
      ageQuery = { from: 0, to: 99, single: parseInt(filterQuery.get('age')) }
    }

    let rangeQuery
    if (filterQuery.get('dateRangeFromYear')) {
      rangeQuery = { from: { year: parseInt(filterQuery.get('dateRangeFromYear')), month: parseInt(filterQuery.get('dateRangeFromMonth')) }, to: { year: parseInt(filterQuery.get('dateRangeToYear')), month: parseInt(filterQuery.get('dateRangeToMonth')) } }
    }

    var today = new Date()

    this.state = {
      filter: {
        category: filterQuery.get('category') || 'all',
        school: filterQuery.get('school') || 'all',
        level: filterQuery.get('level') || 'all',
        license: filterQuery.get('license') || 'all',
        range: rangeQuery || { from: { year: today.getFullYear(), month: today.getMonth() + 1 }, to: { year: today.getFullYear() + 1, month: 12 } },
        age: ageQuery || { from: 0, to: 99, single: 0 }
      },
      childData: null,
      dateCount: 0
    }
    /* TODO: Initial-Filter/Reset vereinfachen */
    this.initialFilter = {
      category: 'all',
      school: 'all',
      level: 'all',
      license: 'all',
      range: { from: { year: today.getFullYear(), month: today.getMonth() + 1 }, to: { year: today.getFullYear() + 1, month: 12 } },
      age: { from: 0, to: 99, single: 0 }
    }

    this.clonedCourses = JSON.parse(JSON.stringify(this.props.courses))

    this.exchangeFilter = this.exchangeFilter.bind(this)
    this.filterVisibility = this.filterVisibility.bind(this)
    this.filterText = this.filterText.bind(this)
    this.filterLevel = this.filterLevel.bind(this)
    this.filterRange = this.filterRange.bind(this)
    this.filterAge = this.filterAge.bind(this)
    this.resetFilters = this.resetFilters.bind(this)
    this.buildDynamicFilters = this.buildDynamicFilters.bind(this)
  }

  /**
   * Reset the filter state to a copy made on init.
   */
  resetFilters () {
    this.setState({
      filter: this.initialFilter
    })
  }

  /**
   * Make a copy of the filter state and replace only the part that changed.
   *
   * @param filter    The new filter value being received.
   * @param type      The identifier, which filter within the state will be replaced.
   */
  exchangeFilter (filter, type) {
    let filterCompare = JSON.parse(JSON.stringify(this.state.filter), (key, value) => {
      if (key === type) {
        return filter
      } else {
        return value
      }
    })
    this.setState({
      filter: filterCompare
    })
  }

  /**
   * Filter course item by visibility status (can be set in the backend)
   *
   * @param item            Course item being filtered.
   */
  filterVisibility (item) {
    return item.isonlybookablebycid !== '1'
  }

  /**
   * Apply the filters for text-fields, e.g. categories, schools, license onto the course items.
   *
   * @param item              Course item being filtered.
   * @var   textFilters       The filters that are being applied from filter state.
   * @var   filteredTermine   Termin items from course item being further filtered.
   * @see   filterVisibility  This function receives its values from previously by-visibility-filtered courses.
   */
  filterText (item) {
    const { category, school, license } = this.state.filter
    const textFilters = { category, school, license }
    for (var key in textFilters) {
      if ((item[key] === undefined || item[key] !== this.state.filter[key]) && this.state.filter[key] !== 'all') {
        return false
      }
    }
    let filteredTermine = item.termine.filter(this.filterRange)
    return (item.termine.length > 0 && item.termine[0] !== undefined) ? ((filteredTermine.length > 0) ? (item.termine = filteredTermine) : false) : false
  }

  /**
   * Apply the date range filter (e.g. from month-picker) onto the termin items.
   *
   * @param item          Termin item being filtered.
   * @var   startYear     Date range starting year extracted from termin item.
   * @var   startMonth    Date range starting month extracted from termin item.
   * @var   endYear       Date range ending year extracted from termin item.
   * @var   endMonth      Date range ending month extracted from termin item.
   * @see   filterText    This function receives its values from previously by-text-filtered courses.
   */
  filterRange (item) {
    let startYear = item.startDate.split('.')[2]
    let startMonth = item.startDate.split('.')[1]
    let endYear = item.endDate.split('.')[2]
    let endMonth = item.endDate.split('.')[1]

    let start = startYear === '1969' || startYear === '1970' ? true : startYear > this.state.filter.range.from.year ? true : startYear < this.state.filter.range.from.year ? false : (startMonth >= this.state.filter.range.from.month)
    let end = endYear === '1969' || endYear === '1970' ? true : endYear < this.state.filter.range.to.year ? true : endYear > this.state.filter.range.to.year ? false : endMonth <= this.state.filter.range.to.month

    return (start && end)
  }

  /**
   * Apply the filters for the entrance level onto the course items.
   * Is true if course item fornewbies = 1 and filter state = 1 (1=beginner)
   * Is true if course item forpros = 1 and filter state = 2 (2=advanced)
   *
   * @param item      Course item being filtered.
   */
  filterLevel (item) {
    if (this.state.filter.level === 'all' || (item.fornewbies === '1' && this.state.filter.level === '1') || (item.forpros === '1' && this.state.filter.level === '2')) {
      return true
    }
    return false
  }

  /**
   * Apply the filters for the age range onto the course items.
   *
   * @param item      Course item being filtered.
   * @var   ageFrom   Condition that matches minimum age in filter state and course item.
   * @var   ageTo     Condition that matches maximum age in filter state and course item.
   */
  filterAge (item) {
    if (this.state.filter.age.single === 0) {
      return true
    } else {
      if (item.agefrom <= this.state.filter.age.single && item.ageto >= this.state.filter.age.single) {
        return true
      } else {
        return false
      }
    }
  }

  /**
   * Build the dynamic filter options. These are the options depending on each other, showing only options that are available after filtering.
   *
   * @param filteredCourses       Array of all courses after filtering.
   * @var   dynamicFilters        Filter options that are available from the already filtered course list.
   * @var   dynamicFilterCategory Dynamic Category filter options.
   * @var   dynamicFilterArea     Dynamic Area filter options.
   * @var   dynamicFilterLicense  Dynamic License filter options.
   * @var   dynamicFilterLevel    Dynamic Level filter options.
   */
  buildDynamicFilters (filteredCourses) {
    let dynamicFilters
    let dynamicFilterCategory = [...new Set(filteredCourses.map(course => course.category))].filter(Boolean).sort()
    dynamicFilterCategory.push('90', '91', '92', '93')
    let dynamicFilterArea = [...new Set(filteredCourses.map(course => course.school))].filter(Boolean).sort((a, b) => a - b)
    let dynamicFilterLicense = [...new Set(filteredCourses.map(course => course.license))].filter(Boolean).sort((a, b) => a - b)
    if (dynamicFilterLicense[0] === '0') {
      dynamicFilterLicense.shift()
    }

    let dynamicFilterNewbies = !![...new Set(filteredCourses.map(course => course.fornewbies))].filter(Boolean).includes('1')
    let dynamicFilterPros = !![...new Set(filteredCourses.map(course => course.forpros))].filter(Boolean).includes('1')
    let dynamicFilterLevel = (dynamicFilterNewbies && dynamicFilterPros) ? ['0', '1', '2'] : (dynamicFilterNewbies && !dynamicFilterPros) ? ['1'] : ['2']

    dynamicFilters = { category: dynamicFilterCategory, school: dynamicFilterArea, license: dynamicFilterLicense, level: dynamicFilterLevel }

    return dynamicFilters
  }

  /**
   * Render the Tabs for Startpage, the Filter-Bar and optionally the course list.
   *
   * @var   filteredCourses     The courses array after filtering.
   * @var   resultsCount        Number of all courses that remain after filtering.
   * @var   list                Display the course list.
   * @var   filterBar           Display the filter bar.
   */
  render () {
    const filteredCourses = this.clonedCourses.filter(this.filterVisibility).filter(this.filterText).filter(this.filterLevel).filter(this.filterAge)
    let resultsCount = filteredCourses.length
    let list
    let filterBar

    if (this.props.view === 'list') {
      list = <List filteredCourses={filteredCourses} resultsCount={resultsCount} />
      filterBar = <Filters resultsCount={resultsCount} usedFilters={this.state.filter} view={this.props.view} staticFilters={this.props.staticFilters} dynamicFilters={this.buildDynamicFilters(filteredCourses)} exchangeFilter={this.exchangeFilter} resetFilters={this.resetFilters} initialFilter={this.initialFilter} targetLink={this.props.targetLink} />
    } else {
      filterBar =
        <Tabs>
          <TabList>
            <Tab>Kurse suchen</Tab>
            <Tab>Mit Kursnummer buchen</Tab>
          </TabList>
          <TabPanel>
            <Filters resultsCount={resultsCount} usedFilters={this.state.filter} view={this.props.view} staticFilters={this.props.staticFilters} dynamicFilters={this.buildDynamicFilters(filteredCourses)} exchangeFilter={this.exchangeFilter} resetFilters={this.resetFilters} initialFilter={this.initialFilter} targetLink={this.props.targetLink} />
          </TabPanel>
          <TabPanel>
            <DirectSearch courses={this.props.courses} />
          </TabPanel>
        </Tabs>
    }
    return (
      <div className='kursfinder'>
        {filterBar}
        {list}
      </div>
    )
  }
}

export default Kursfinder
